/**
 * Import Lib
 */

import React, { useContext } from "react";
/**
 * Import Context
 */

import { ContentContext } from "context/contentContext";
import { DataContext } from "context/dataContext";

/**
 * import assets
 */

/**
 * import containers & components
 */

import Layout__container from "containers/layout/container/layout__container";
import Layout__content from "containers/layout/content/layout__content";
import { Content__heading } from "components/content/content";
import { Form__steps } from "components/form/form";

/**
 * @name Home
 */

const Home = () => {
  const { content, c } = useContext(ContentContext);
  const { steps } = useContext(DataContext);

  return (
    <Layout__container pageName={content.home.config.page_name}>
      <Layout__content>
        <Content__heading title={c("home.heading.title")} subtitle={c("home.heading.subtitle")} />
        <Form__steps steps={steps} />
      </Layout__content>
    </Layout__container>
  );
};

export default Home;
